function loadViewStudio(view) {
    return () => import( /* webpackChunkName: "internships-[request]" */ `../views/Studio/${view}.vue`)
}

const routes = [
    {
        path: '/verify-studio',
        name: 'VerifyStudio',
        meta: {
        requiresAuth: true,
        roleVerif: false,
        role: []
        },
        component: loadViewStudio('VerifyStudio')
    },
    {
        path: '/studio',
        name: 'Studio',
        meta: {
        requiresAuth: true,
        roleVerif: false,
        role: []
        },
        component: loadViewStudio('Studio')
    },
    {
        path: '/studio/:studio_id',
        name: 'ListStudioEvaluation',
        meta: {
        requiresAuth: true,
        roleVerif: false,
        role: []
        },
        component: loadViewStudio('ListStudioEvaluation')
    },
    {
        path: '/studio/:studio_id/:studio_evaluation_id',
        name: 'ListStudioEvaluationQuestion',
        meta: {
        requiresAuth: true,
        roleVerif: false,
        role: []
        },
        component: loadViewStudio('ListStudioEvaluationQuestion')
    },
    {
        path: '/studio-tester',
        name: 'StudioTester',
        meta: {
        requiresAuth: true,
        roleVerif: false,
        role: ['kaprodi','sekprodi']
        },
        component: loadViewStudio('StudioTester')
    },
    {
        path: '/studio-evaluation',
        name: 'StudioEvaluation',
        meta: {
        requiresAuth: true,
        roleVerif: false,
        role: ['kaprodi','sekprodi']
        },
        component: loadViewStudio('StudioEvaluation')
    },
    {
        path: '/studio-evaluation/:studio_evaluation_id',
        name: 'StudioEvaluationQuestion',
        meta: {
        requiresAuth: true,
        roleVerif: false,
        role: ['kaprodi','sekprodi']
        },
        component: loadViewStudio('StudioEvaluationQuestion')
    },
]

export default routes